import React, { ReactElement } from 'react';
import Secured from '../Secured';
import UserRole from '../../model/currentuser/UserRole';
import PodporovatelListComponent from './component/PodporovatelListComponent';

const PodporovatelList = (): ReactElement => (
  <Secured allowForRoles={[UserRole.VYHODNOCOVATEL, UserRole.SUPERADMIN]}>
    <PodporovatelListComponent />
  </Secured>
);

export default PodporovatelList;
